import { Component, OnInit, Input, ChangeDetectorRef } from '@angular/core';
import { IAreachartdata } from '@app/interfaces/IAreachartdata';
import { curveCardinal } from 'd3-shape';
@Component({
  selector: 'app-area-chart',
  templateUrl: './area-chart.component.html',
  styleUrls: ['./area-chart.component.scss']
})
export class AreaChartComponent implements OnInit {
  @Input() data: any; //data coming from parent component
  @Input() colorScheme: any //colorscheme passed through parent component
  @Input() graphStyle: IAreachartdata //styles coming from parent component
  constructor() { }

  results: any;
  curve = curveCardinal.tension(0.1);

  ngOnInit(): void {
    this.colorScheme = this.colorScheme ? this.colorScheme : { domain: [] }
  }
  /**
   * Function to update the chart data on select
   */
  detectChange() {
    this.data = [...this.data]
  }

}
